import type { CustomerType, UserType } from '@/store/types/user'

type Props = {
  market: string
  skus: string[]
}

type Level = {
  currency: string
  customer: CustomerType
  item: Item
  kitChildren: KitChild[]
  quantity: number
  quantityLimit: QuantityLimit
  terms: Terms
}

type Item = {
  catalogSlide: CatalogSlide
  dimensionsEach: DimensionsEach
  id: ItemID
  taxedAs: string
  href: string
}

type CatalogSlide = {
  content: Content
}

type Content = {
  description: string
}

type DimensionsEach = {
  depth: number
  height: number
  unit: string
  width: number
}

type ItemID = {
  unicity: string
}

type KitChild = {
  item: Item
  terms: KitChildTerms
}

type KitChildTerms = {
  cvEach: number
  discountEach: Amount
  priceEach: string
  pvEach: number
  tax: Tax
  taxEach: Amount
  taxablePriceEach: number
}

type Amount = {
  amount: number
}

type Tax = {
  categoryDescription: string
}

type QuantityLimit = {
  quantityOrdered: number
  quantityQuota: number
  timeFrameDays: number
}

type Terms = {
  cvEach: number
  discountEach: Amount
  priceEach: number
  pvEach: number
  tax: Tax
  taxEach: Amount
  taxablePriceEach: number
}

export type JeevesPricingResponse = {
  message: JeevesPricingType[]
}

export type JeevesPricingType = {
  sku: string
  levels: Level[]
}

export type QuotesPricingType = {
  sku: string
  levels: Level[]
} | null
export type QuotesResponse = {
  items: QuotesItemType[]
}
export type QuotesItem = {
  item: Item
  kitChildren: KitChildTerms[]
  quantity: number
  quantityLimit: QuantityLimit
  terms: Terms
}
export type QuotesItemType = {
  currency: string
  customer: { type: UserType }
  lines: {
    items: QuotesItem[]
  }
}

export const JeevesGetProductPricing = async ({ market, skus }: Props) => {
  const jeevesBaseURL = `${process.env.NEXT_PUBLIC_JEEVES_BASE_URL}/api/v2/catalog/shop`

  const response = await fetch(jeevesBaseURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
      market,
      items: skus.map((sku) => ({ sku })),
      bypassCache: 1,
    }),
  })
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const data: JeevesPricingResponse =
    (await response.json()) as JeevesPricingResponse
  return data
}
